export default __webpack_public_path__ + "static/media/EXPLODE.164ff5f5.jpg";